//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GCarousel from '~/components/public/carousel/main.vue';
import GCarouselItem from '~/components/public/carousel/item.vue';
export default {
  components: {
    GCarousel,
    GCarouselItem,
  },
  props: {
    swiperRight: {
      type: Array,
      default() {
        return [];
      },
    },
    swiperLeft: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
      timer: '',
    };
  },
  mounted() {
    clearInterval(this.timer);
  },
  methods: {
    changepage(type) {
      this.stop();
      switch (type) {
        case 'left':
          this.currentIndex =
            this.currentIndex === 0
              ? this.swiperLeft.length - 1
              : this.currentIndex - 1;
          break;
        case 'right':
          this.currentIndex =
            this.currentIndex === this.swiperLeft.length - 1
              ? 0
              : this.currentIndex + 1;
          break;
      }
      this.go();
    },
    go() {
      this.timer = setInterval(() => {
        this.autoPlay();
      }, 6000);
    },
    stop() {
      clearInterval(this.timer);
      this.timer = null;
    },
    change(index) {
      this.currentIndex = index;
    },
    beforeDestroy() {
      this.stop();
    },
    autoPlay() {
      this.currentIndex++;
      if (this.currentIndex > this.swiperLeft.length - 1) {
        this.currentIndex = 0;
      }
    },
  },
};
